// imports
import * as THREE from "three"

// classes
import Experience from "../../Experience"

export default class Terrain
{
    constructor()
    {
        // setup
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resourceLoader = this.experience.resourceLoader

        this.setTextures()
        this.setInstance()
    }

    setTextures()
    {
        this.textures = {}
        this.textures.color = this.resourceLoader.items.terrainColor
        this.textures.normal = this.resourceLoader.items.terrainNormal

        this.textures.color.repeat.set( 1.5, 1.5 )
        this.textures.normal.repeat.set( 1.5, 1.5 )

        this.textures.color.wrapS = THREE.RepeatWrapping
        this.textures.color.wrapT = THREE.RepeatWrapping
        this.textures.normal.wrapS = THREE.RepeatWrapping
        this.textures.normal.wrapT = THREE.RepeatWrapping
    }

    setInstance()
    {
        this.instanceParameter =
        {
            map: this.textures.color,
            normal: this.textures.normal,

            position:
            {
                x: 0,
                y: 0,
                z: 0
            },

            rotation:
            {
                x: -Math.PI * 0.5,
                y: 0,
                z: 0
            }
        }

        this.instanceMaterial = new THREE.MeshStandardMaterial( 
        {
            map: this.instanceParameter.map,
            normalMap: this.instanceParameter.normal,
        } )
        this.instanceGeometry = new THREE.CircleGeometry( 12, 32 )
        this.instance = new THREE.Mesh( this.instanceGeometry, this.instanceMaterial )

        this.instance.position.set( ...Object.values( this.instanceParameter.position ) )
        this.instance.rotation.set( ...Object.values( this.instanceParameter.rotation ) )
        this.instance.receiveShadow = true
        this.instance.castShadow = true

        this.scene.add( this.instance )
    }
}